// Sessão por GUIA do navegador.
// sessionStorage é isolado por guia → cada guia pode operar numa organização
// diferente ao mesmo tempo. O localStorage guarda a "sessão padrão" do
// navegador (definida no login): guia nova abre nela e o seletor de
// organização troca SÓ a guia atual.
//
// Usuário marcado com "sempre_pedir_login" nunca deve reaproveitar a sessão
// padrão do localStorage — só a da própria guia (sessionStorage), que sempre
// existiu quando ele estiver logado ativamente. Sem sessionStorage e com o
// flag ligado, mesmo que reste um token antigo no localStorage (ex.: de um
// login anterior a essa flag ter sido marcada), ele é descartado aqui.
function podeUsarSessaoPadrao() {
  try {
    const usuario = JSON.parse(localStorage.getItem('erp_usuario') || 'null');
    if (usuario?.sempre_pedir_login) {
      limparSessao();
      return false;
    }
  } catch { /* localStorage corrompido: segue o fluxo normal */ }
  return true;
}

export function getToken() {
  const daGuia = sessionStorage.getItem('erp_token');
  if (daGuia) return daGuia;
  return podeUsarSessaoPadrao() ? localStorage.getItem('erp_token') : null;
}

export function getUsuarioSessao() {
  try {
    const daGuia = sessionStorage.getItem('erp_usuario');
    if (daGuia) return JSON.parse(daGuia);
    return podeUsarSessaoPadrao() ? JSON.parse(localStorage.getItem('erp_usuario') || 'null') : null;
  } catch {
    return null;
  }
}

export function limparSessao() {
  sessionStorage.removeItem('erp_token');
  sessionStorage.removeItem('erp_usuario');
  localStorage.removeItem('erp_token');
  localStorage.removeItem('erp_usuario');
}

// ── Hand-off de sessão para guia nova ────────────────────────────────────────
// Guia aberta com noopener NÃO herda o sessionStorage: sem isto, o PDV aberto
// de uma guia trocada p/ outra organização carregava a organização do último
// LOGIN (padrão do localStorage). A guia de origem grava a própria sessão numa
// chave temporária e passa só um código (nonce) na URL — a guia nova resgata,
// assume a sessão e apaga a chave (uso único, validade 60s).
// App instalado (PWA do Chrome/Edge): a janela não tem guias, e um
// window.open "de guia" fica a critério do navegador — vai pra uma guia do
// navegador comum ou nem abre outra janela do app. Com features de janela
// ("popup" + tamanho), o navegador sempre abre uma janela separada, então dá
// pra ter vários PDVs no mesmo PC igual no navegador.
export function rodandoComoApp() {
  try {
    return ['standalone', 'window-controls-overlay', 'minimal-ui', 'fullscreen']
      .some(m => window.matchMedia?.(`(display-mode: ${m})`).matches) || window.navigator.standalone === true;
  } catch { return false; }
}

function featuresJanela() {
  const base = 'noopener,noreferrer';
  if (!rodandoComoApp()) return base;
  const w = window.screen?.availWidth || 1280;
  const h = window.screen?.availHeight || 800;
  return `${base},popup,left=0,top=0,width=${w},height=${h}`;
}

export function abrirComSessao(to) {
  const token   = sessionStorage.getItem('erp_token');
  const usuario = sessionStorage.getItem('erp_usuario');
  if (token && usuario) {
    const nonce = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(`erp_handoff_${nonce}`, JSON.stringify({ token, usuario, ts: Date.now() }));
    window.open(`${to}#sessao=${nonce}`, '_blank', featuresJanela());
  } else {
    window.open(to, '_blank', featuresJanela());
  }
}

// Executa no carregamento do módulo (antes do AuthContext/api lerem a sessão):
// resgata o hand-off apontado pelo #sessao= da URL e limpa chaves velhas.
(function resgatarHandoff() {
  try {
    for (const k of Object.keys(localStorage)) {
      if (!k.startsWith('erp_handoff_')) continue;
      try {
        const { ts } = JSON.parse(localStorage.getItem(k));
        if (Date.now() - (ts || 0) > 60_000) localStorage.removeItem(k);
      } catch { localStorage.removeItem(k); }
    }
    const m = window.location.hash.match(/sessao=([a-z0-9]+)/i);
    if (!m) return;
    const chave = `erp_handoff_${m[1]}`;
    const raw = localStorage.getItem(chave);
    localStorage.removeItem(chave); // uso único
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    if (!raw) return;
    const { token, usuario, ts } = JSON.parse(raw);
    if (!token || !usuario || Date.now() - (ts || 0) > 60_000) return;
    sessionStorage.setItem('erp_token', token);
    sessionStorage.setItem('erp_usuario', usuario);
  } catch { /* sessão segue o fluxo normal */ }
})();
